<template>
  <!-- Toast -->
  <div class="fixed bottom-[100px] right-6 z-[10000] flex flex-col gap-2 max-w-[calc(100vw-2rem)] sm:max-w-[300px]">
    <transition-group name="toast">
      <div
        v-for="toast in filteredToasts"
        :key="toast.id"
        class="bg-white/95 backdrop-blur-sm shadow-2xl border border-gray-200/50 rounded-lg p-4 flex items-center gap-3 min-w-[300px] transform transition-all duration-300"
        :class="{
          'border-l-4 border-[#29B533]': toast.type === 'error',
          'border-l-4 border-[#3D1951]': toast.type === 'info',
          'border-l-4 border-green-500': toast.type === 'success',
          'border-l-4 border-amber-500': toast.type === 'warning'
        }"
      >
        <!-- Icon -->
        <div class="flex-shrink-0">
          <svg
            v-if="toast.type === 'error'"
            class="h-5 w-5 text-[#29B533]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg
            v-if="toast.type === 'warning'"
            class="h-5 w-5 text-amber-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <svg
            v-if="toast.type === 'info'"
            class="h-5 w-5 text-[#3D1951]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg
            v-if="toast.type === 'success'"
            class="h-5 w-5 text-green-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <!-- Content -->
        <div class="flex-1">
          <p class="text-sm font-medium text-gray-900">
            {{ toast.title }}
          </p>
          <p class="mt-1 text-sm text-gray-500" v-if="toast.message">
            {{ toast.message }}
          </p>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useDialog } from '@/composables/useDialog'

interface Props {
  toastTab?: string
}

const props = withDefaults(defineProps<Props>(), {
  toastTab: undefined
})

const { removeToast, state } = useDialog()

const filteredToasts = computed(() => {
  if (!props.toastTab) {
    return state.toasts
  }
  return state.toasts.filter(toast => toast.toastTab === props.toastTab)
})
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
